var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInventory(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4H10.6667C10.6667 2.52667 9.47333 1.33333 8 1.33333C6.52667 1.33333 5.33333 2.52667 5.33333 4H4C3.26667 4 2.66667 4.6 2.66667 5.33333V13.3333C2.66667 14.0667 3.26667 14.6667 4 14.6667H12C12.7333 14.6667 13.3333 14.0667 13.3333 13.3333V5.33333C13.3333 4.6 12.7333 4 12 4ZM8 2.66667C8.73333 2.66667 9.33333 3.26667 9.33333 4H6.66667C6.66667 3.26667 7.26667 2.66667 8 2.66667ZM12 13.3333H4V5.33333H5.33333V6.66667C5.33333 7.03333 5.63333 7.33333 6 7.33333C6.36667 7.33333 6.66667 7.03333 6.66667 6.66667V5.33333H9.33333V6.66667C9.33333 7.03333 9.63333 7.33333 10 7.33333C10.3667 7.33333 10.6667 7.03333 10.6667 6.66667V5.33333H12V13.3333Z",
    fill: "#264F3F"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInventory);
export default __webpack_public_path__ + "static/media/inventory.4d2ae31d.svg";
export { ForwardRef as ReactComponent };